import { httpClient } from '../http/httpClient'

export async function userUnicoApprove(id: string) {
  const { data } = await httpClient.patch(`/user/${id}/unicoApprove`)

  return data
}
